<fieldset [formGroup]="skjema()" data-testid="oppgave-skjema">

  <mat-form-field class="tittel">
    <mat-label>{{ tittelLabel() }}</mat-label>
    <input matInput [formControl]="skjema().controls.tittel" cdkFocusInitial data-testid="oppgave-tittel-felt">
    @if (skjema().controls.tittel.hasError('maxlength')) {
      <mat-error data-testid="maxlength">{{ skjema().controls.tittel.errors | standardvalideringsfeil:'maxlength' }}
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field class="beskrivelse">
    <mat-label>{{ 'Beskrivelse'|translate }}</mat-label>
    <riktekst-redigering [skjemakontroll]="skjema().controls.beskrivelse" [gruppeId]="gruppeId()" data-testid="oppgave-beskrivelse-felt"/>
  </mat-form-field>

  <div class="ansvarlig-frist">
    <mat-form-field class="ansvarlig">
      <mat-label>{{ 'Ansvarlig'|translate }}</mat-label>
      <velg-medlem [skjemakontroll]="skjema().controls.ansvarlig" [medlemmer]="tilgjengeligeMedlemmer()" tillatIngenValgt="false" data-testid="oppgave-ansvarlig-felt"/>
    </mat-form-field>

    <mat-form-field class="frist">
      <mat-label>{{ "Frist"|translate }}</mat-label>
      <input matInput [formControl]="skjema().controls.frist" [matDatepicker]="fristVelger" data-testid="oppgave-frist-felt">
      <mat-datepicker-toggle matPrefix [for]="fristVelger"/>
      <mat-datepicker #fristVelger/>
      @if (skjema().controls.frist.hasError('matDatepickerParse')) {
        <mat-error data-testid="matDatepickerParse">
          {{ skjema().controls.frist.errors | standardvalideringsfeil:'matDatepickerParse' }}
        </mat-error>
      }
    </mat-form-field>
  </div>

</fieldset>
